<template>
  <div class="card-container">
    <div class="name">
      <span>{{ addon.name }}</span>
      <div class="tooltip-container">
        <img src="/assets/images/tooltip.svg" alt="tooltip-icon">
        <div class="tariff-tooltip-text"> {{ addon.description }}</div>
      </div>
    </div>
    <div class="rows-container">
      <div>
      <template v-for="(specification, index) in addon.productSpecCharacteristicValues">
        <div :key="index"
             v-if="specification.characteristicGroupCommerceType !== 'ADDON_ACTIVATION'"
             class="card-row">
          <img :src="specification.icon.url" alt="specification.characteristicName">
          <div>
            <span>{{ specification.characteristicName }}: </span>
            <span>{{ specification.description }}</span>
          </div>
        </div>
      </template>
    </div>
      <div>
        <div v-if="hasFormattedPrice" class="price">
          <span id="amount">{{ addon.price.formattedValue }}</span>
          <span id="currency">{{ $t('plpAddonsPage.currency') }}</span>
        </div>
        <BaseButton variant="secondary" @click="openModal" :block="true">{{
            $t('plpAddonsPage.buttonText')
          }}
        </BaseButton>
      </div>
    </div>
    <modal :visible="modalStatus"
           @modal-close="closeModal">
      <template #body>
        <AddonModalContent :activateAddonInfo="activateAddonInfo"/>
      </template>
    </modal>
  </div>
</template>

<script>

import BaseButton from '../base/base-button'
import Modal from '../common/modal/modal'
import AddonModalContent from './addon-modal-content'

export default {
  name: 'plp-addon-card',
  components: { BaseButton, Modal, AddonModalContent },
  props: {
    addon: {
      type: Object
    }
  },
  data () {
    return {
      modalStatus: false,
      activateAddonInfo: {}
    }
  },
  computed: {
    hasFormattedPrice () {
      return this.addon.price?.formattedValue
    }
  },
  methods: {
    openModal () {
      this.modalStatus = !this.modalStatus
      this.activateAddonInfo = this.addon.productSpecCharacteristicValues.filter(add => add.characteristicGroupCommerceType === 'ADDON_ACTIVATION')
    },
    closeModal () {
      this.modalStatus = false
    }
  }
}

</script>

<style scoped lang="scss">
.card-container {
  width: 320px;
  border-radius: 5px;
  padding: 15px;
  background-color: $white;
  margin: 10px;
  display: flex;
  flex-direction: column;
  @media (map_get($breakpoints, sm)) {
    height: 100%;
  }

  .name {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.17;
    color: $dark;
    margin-bottom: 30px;
    @media (map_get($breakpoints, sm)) {
      min-height: 60px;
    }

  }

  .rows-container {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;

    .card-row {
      margin-bottom: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid $grey;
      display: flex;
      align-items: center;

      img {
        height: 30px;
        width: 30px;
        margin-right: 16px;
        margin-top: 4px;
      }

      span {
        font-size: 16px;
        line-height: 1.25;
        color: $dark-grey;
      }

      &:last-of-type {
        border-bottom: none;
      }
    }
  }

  .price {
    margin-bottom: 15px;

    #amount {
      font-size: 24px;
      font-weight: 600;
      color: $primary;
      margin-right: 10px;
    }

    #currency {
      font-size: 16px;
      font-weight: 600;
      color: $dark;
      margin-top: -3px;
    }
  }

  .tooltip-container {
    position: relative;
    width: fit-content;
    img {
      max-width: 14px;
      max-height: 14px;
    }

    &:hover {
      cursor: pointer;

      .tariff-tooltip-text {
        display: block;
        word-break: normal;
      }
    }
  }

  .tariff-tooltip-text {
    background: white;
    padding: 10px;
    min-width: 200px;
    max-width: 300px;
    position: absolute;
    top: 0;
    right: 100px;
    transform: translate(calc(50% + 20px), calc(20px));
    z-index: 1;
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    font-size: 12px;
    display: none;
    word-break: break-all;
  }
}

</style>
